const FEATURES = [
  { title: "AI Copywriting", desc: "Generate blog posts, ads, emails, and social media content with GPT-5.2", icon: "P" },
  { title: "Image Generation", desc: "Create stunning marketing visuals with Nano Banana AI", icon: "I" },
  { title: "Brand Voice", desc: "Customize AI output to match your unique brand personality", icon: "B" },
  { title: "Templates Library", desc: "Access 100+ pre-built templates for any content type", icon: "T" },
  { title: "Content History", desc: "Save and organize all your generated content", icon: "H" },
  { title: "Global Scale", desc: "Works in 50+ languages for global reach", icon: "G" },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-24 px-8 md:px-16">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#0066FF] mb-4 text-center">Features</p>
        <h2 className="text-3xl sm:text-4xl tracking-tight font-bold text-center mb-16">Everything You Need to Create</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="border border-black p-8 hover:-translate-y-1 transition-transform hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"
              data-testid={`feature-${feature.title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="w-12 h-12 bg-[#0066FF] text-white flex items-center justify-center font-black text-xl mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
